import React, { useContext } from "react";

import { SessionContext } from "@mne-authentication/session2";
import { createCsrfToken } from "@mne-core/api";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";

interface ISwaggerUIViewProps {
  swaggerUrl: string;
}

export const SwaggerUIView = ({ swaggerUrl }: ISwaggerUIViewProps) => {
  const { session } = useContext(SessionContext);

  const swaggerUIProps: React.ComponentProps<typeof SwaggerUI> = {
    url: swaggerUrl,
    plugins: [
      /* IMPORTANT */
      /* This plugin us used to remove the InfoContainer as it takes up to much space and is relying on the name defined in this file: https://github.com/swagger-api/swagger-ui/blob/master/src/core/components/layouts/base.jsx */
      /* When upgrading swagger-ui-react, make sure that the name of this component matches the one defined in the file */
      () => ({
        components: {
          InfoContainer: () => null,
        },
      }),
    ],
    /* This ensures that none of the endpoints are expanded when you load the page to make it easier to navigate */
    docExpansion: "none",
    /* Enables the request snippet section. When disabled, the legacy curl snippet will be used. The default is false. */
    requestSnippetsEnabled: true,
    /* Controls how the model is shown when the API is first rendered. (The user can always switch the rendering for a given model by clicking the 'Model' and 'Example Value' links.) The default value is 'example'. 
       if this is flipped to model a bug is introduced that makes it impossible to look into the objects in the data in the response */
    defaultModelRendering: "example",
    /* This removes Argus-CSRF-Token from the snippet as the session cookie is also required to execute the query, so using it wont work */
    showMutatedRequest: false,
    /* The purpose of this function is to re-assign the request with our CSRF token and to make sure Argus-API-Key takes precedence over the CSRF token */
    requestInterceptor: (req) => {
      /* We do not want to authenticate using the session if an api key is provided through the "authorize" button (this is then handled by SwaggerUI): */
      if (session?.info?.sessionKey && !req?.headers?.["Argus-API-Key"]) {
        const csrfToken = createCsrfToken(session.info.sessionKey, req.url);
        req = Object.assign({}, req, {
          credentials: "include",
          headers: Object.assign({}, req.headers, { "Argus-CSRF-Token": csrfToken }),
        });
      }
      return req;
    },
  };

  return <SwaggerUI {...swaggerUIProps} />;
};
